// Generated from java-escape by ANTLR 4.11.1
// jshint ignore: start
import antlr4 from 'antlr4';

// This class defines a complete generic visitor for a parse tree produced by QueryExprParser.

export default class QueryExprVisitor extends antlr4.tree.ParseTreeVisitor {

	// Visit a parse tree produced by QueryExprParser#rootExpression.
	visitRootExpression(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#MapExpr.
	visitMapExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#AndExpr.
	visitAndExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#EqualExpr.
	visitEqualExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#MultiplyExpr.
	visitMultiplyExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#UnaryNotExpr.
	visitUnaryNotExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#RaiseToExpr.
	visitRaiseToExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#IndexExpr.
	visitIndexExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#DivideExpr.
	visitDivideExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#MemberExpr.
	visitMemberExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#IdentifierExpr.
	visitIdentifierExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#LiteralExpr.
	visitLiteralExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#ListExpr.
	visitListExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#InExpr.
	visitInExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#LessThanExpr.
	visitLessThanExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#GreaterThanExpr.
	visitGreaterThanExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#AddExpr.
	visitAddExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#NotEqualExpr.
	visitNotEqualExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#OrExpr.
	visitOrExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#WithoutExpr.
	visitWithoutExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#LessThanOrEqualExpr.
	visitLessThanOrEqualExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#ConcatExpr.
	visitConcatExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#FunctionCallExpr.
	visitFunctionCallExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#UnaryPlusExpr.
	visitUnaryPlusExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#ParenthesizedExpr.
	visitParenthesizedExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#SubtractExpr.
	visitSubtractExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#WithExpr.
	visitWithExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#ModExpr.
	visitModExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#UnaryMinusExpr.
	visitUnaryMinusExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#GreaterThanOrEqualExpr.
	visitGreaterThanOrEqualExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#NullLiteral.
	visitNullLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#TrueLiteral.
	visitTrueLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#FalseLiteral.
	visitFalseLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#DateLiteral.
	visitDateLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#TimeLiteral.
	visitTimeLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#DateTimeLiteral.
	visitDateTimeLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#StringLiteral.
	visitStringLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#NumberLiteral.
	visitNumberLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#IntegerLiteral.
	visitIntegerLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#list.
	visitList(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#map.
	visitMap(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#keyValues.
	visitKeyValues(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#keyValue.
	visitKeyValue(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#key.
	visitKey(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#functionCall.
	visitFunctionCall(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#callArgs.
	visitCallArgs(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#values.
	visitValues(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by QueryExprParser#identifier.
	visitIdentifier(ctx) {
	  return this.visitChildren(ctx);
	}



}